import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CanvasDetails = lazy(() =>
  import("@canvas/CanvasDetails").then((module) => ({ default: module.CanvasDetails }))
);

export const canvasDetailsNRO: NavigationRoutingObject = {
  Component: CanvasDetails,
  componentFeatureFlippers: ["canvas_nro_component", "canvas_details_nro_component"],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("canvas-sidebar-pill-menu-option", "Canvas"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "canvas-sidebar-pill-menu-option-description",
      "Manage your existing Canvases or create a new one. Recommended for user journeys."
    ),
  icon: "new-nav-system-canvas",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("journeys");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/canvas/:appGroupId",
};
